import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import Field from '@/packages/field';
import DictApi from '@/api/dict';
import { InfoComplementField } from '../../types';

const style = require('./index.module.scss') as Dictionary;

@Component({ name: 'LiveStatus' })
export default class LiveStatus extends Vue implements InfoComplementField {
  @Prop()
  private value!: undefined | number;

  private liveStatus: undefined | number | null = null;

  private created() {
    if (this.value) {
      this.liveStatus = this.value;
    }
  }

  @Watch('value')
  private onValueChange(val: undefined | number) {
    if (val !== this.liveStatus) {
      this.liveStatus = val;
    }
  }

  public onValidator(): boolean {
    return this.liveStatus !== null && typeof this.liveStatus !== 'undefined';
  }

  private onChangeLiveStatus(val: number | undefined | null) {
    this.$emit('change', val);
  }

  private render() {
    return (
      <div class={style.LiveStatus}>
        <Field
          v-model={this.liveStatus}
          label="居住状态"
          sub={true}
          onChange={() => this.onChangeLiveStatus(this.liveStatus)}
          type="select"
          dictApi={DictApi.getLiveStatus}
          readonly={true}
        />
      </div>
    );
  }
}
